import { NOTIFICATION_TYPES } from "./types";

function normalizePreview(preview) {
  return String(preview || "").trim().slice(0, 240);
}

function normalizeAuthor(authorName) {
  const name = String(authorName || "").trim();
  return name || "Alguém";
}

function isDirectMessageSpace(spaceType) {
  return String(spaceType || "").trim().toLowerCase() === "dm";
}

/** Mesma regra do backend (`teamNotificationCopy.js`). */
export function buildTeamNotificationCopy({
  spaceType,
  spaceName,
  authorName,
  preview,
  isMention = false,
}) {
  const author = normalizeAuthor(authorName);
  const text = normalizePreview(preview);
  const spaceLabel = String(spaceName || "").trim();
  const dm = isDirectMessageSpace(spaceType);
  const channelLabel =
    spaceLabel && spaceLabel !== "Mensagem direta" ? spaceLabel : "Equipe";

  if (isMention) {
    if (dm) {
      return {
        title: author,
        body: text || "mencionou você",
      };
    }
    return {
      title: author,
      body: text
        ? `mencionou você em ${channelLabel}: ${text}`
        : `mencionou você em ${channelLabel}`,
    };
  }

  if (dm) {
    return {
      title: author,
      body: text || "Nova mensagem",
    };
  }

  if (spaceLabel && spaceLabel !== "Mensagem direta") {
    return {
      title: spaceLabel,
      body: text ? `${author}: ${text}` : author,
    };
  }

  return {
    title: author,
    body: text || "Nova mensagem na equipe",
  };
}

function stripAuthorPrefix(body) {
  const b = String(body || "").trim();
  const idx = b.indexOf(": ");
  if (idx <= 0 || idx > 80) return b;
  return b.slice(idx + 2).trim() || b;
}

function looksLikeLegacyTeamTitle(title) {
  const value = String(title || "").trim();
  return (
    value === "Mensagem direta" ||
    value === "Nova mensagem na equipe" ||
    value.startsWith("Menção em ")
  );
}

/** Resolve título/corpo para alertas de equipe (socket ou fallback). */
export function resolveTeamNotificationDisplay({ data, eventType, t }) {
  const isMention = eventType === NOTIFICATION_TYPES.team_mention;
  const authorName = data?.authorName ?? data?.author_name ?? null;
  const spaceType = data?.spaceType ?? data?.space_type ?? null;
  const spaceName = data?.spaceName ?? data?.space_name ?? null;
  const rawBody = String(data?.body || "");
  const legacyMatch = rawBody.match(/^([^:]{1,80}):\s([\s\S]+)$/);
  const preview =
    data?.preview ??
    (authorName ? stripAuthorPrefix(rawBody) : legacyMatch ? legacyMatch[2].trim() : rawBody);

  const resolvedAuthor = authorName || (legacyMatch ? legacyMatch[1].trim() : null);
  const resolvedSpaceType =
    spaceType || (data?.title === "Mensagem direta" ? "dm" : null);

  if (resolvedAuthor || preview || resolvedSpaceType) {
    return buildTeamNotificationCopy({
      spaceType: resolvedSpaceType,
      spaceName: spaceName || data?.title || null,
      authorName: resolvedAuthor,
      preview,
      isMention,
    });
  }

  if (data?.title && data?.body && !looksLikeLegacyTeamTitle(data.title)) {
    return { title: data.title, body: data.body };
  }

  return {
    title: isMention ? t("titles.teamMention") : t("titles.teamMessage"),
    body: rawBody,
  };
}
